if (!customElements.get('quickbuy-widget')) {
  customElements.define('quickbuy-widget', class QuickbuyWidget extends HTMLElement {
    connectedCallback() {
      this.optionSelects = this.querySelectorAll('[data-option-select]');
      this.mainSelect = this.querySelector('[data-main-select]');
      this.addButton = this.querySelector('[data-action="add-to-cart"]');
      this.sizeSelect = Array.from(this.optionSelects).find(node => node.querySelector('option[data-select-reminder]'));

      this.onChange = this.handleChange.bind(this);
      this.addEventListener('change', this.onChange);
      this.syncVariant();
      this.updateAddButtonState();

      const isNewAdd = String(this.dataset.newAdd).toLowerCase() === 'true';
      const isInsole = String(this.dataset.insole).toLowerCase() === 'true';
      if (isNewAdd && isInsole) this.autoselectFromCart();
    }

    handleChange() {
      this.syncVariant();
      this.updateAddButtonState();
    }

    syncVariant() {
      if (!this.mainSelect) return;
      const targetLabel = Array.from(this.optionSelects).map(node => (node.value || '').trim()).join('-').trim();
      Array.from(this.mainSelect.options).forEach(optionElement => {
        const label = (optionElement.innerText || optionElement.textContent || '').trim();
        if (label === targetLabel) {
          optionElement.setAttribute('selected', 'selected');
          this.mainSelect.value = optionElement.value;
        } else {
          optionElement.removeAttribute('selected');
        }
      });
    }

    updateAddButtonState() {
      if (!this.addButton || !this.sizeSelect) return;
      const selectedOption = this.sizeSelect.options[this.sizeSelect.selectedIndex];
      const isReminderSelected = !!(selectedOption && selectedOption.hasAttribute('data-select-reminder'));
      const isDisabledSelected = !!(selectedOption && selectedOption.disabled);
      this.addButton.disabled = isReminderSelected || isDisabledSelected;
    }
    
    selectReminderOption() {
      if (!this.sizeSelect) return;
      const reminderOption = this.sizeSelect.querySelector('option[data-select-reminder]');
      if (!reminderOption) return;
      reminderOption.selected = true;
      this.sizeSelect.value = reminderOption.value;
      this.sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    async autoselectFromCart() {
      let response, cartData;
      try {
        response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        cartData = await response.json();
      } catch { return; }

      const cartItems = Array.isArray(cartData?.items) ? cartData.items : [];
      let foundFootwear = false;
      let chosenSize = null;
      let mismatch = false;

      for (const item of cartItems) {
        let category = item?.properties._category.toLowerCase() || '';
        if (category !== 'footwear') continue;

        let size = String(Math.ceil(item.options_with_values[0].value)); //Round sizes up since insoles don't come in half sizes
        if (!size) { mismatch = true; break; }

        if (!foundFootwear) {
          chosenSize = size
          foundFootwear = true;
        } else if (chosenSize !== size) {
          mismatch = true;
          break;
        }
      }

      if (!foundFootwear || mismatch) {
        this.selectReminderOption();
        this.updateAddButtonState();
        return;
      }

      if (!this.sizeSelect) return;
      const match = Array.from(this.sizeSelect.options).find(opt => {
        const val  = String(opt.value).trim();
        return val === chosenSize;
      });

      if (!match || match.disabled) {
        this.selectReminderOption();
        this.updateAddButtonState();
        return;
      }

      this.sizeSelect.value = match.value;
      this.sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      this.syncVariant();
      this.updateAddButtonState();
    }
  });
}